import useCaseList from "../../features/cases/useCaseList";
import CaseListDesktop from "../cases/CaseListDesktop";
import { EAUCTION_CONFIG } from "./eauctionConfig";

const LIST = { endpoint: "/eauctions", pollMs: 30000 };

const EauctionDesktop = () => (
  <CaseListDesktop config={EAUCTION_CONFIG} list={useCaseList(LIST)} />
);

export default EauctionDesktop;
